export default "__VITE_ASSET__A1P15DSF__"